import { MaterialCommodity, Weld } from '@bechtel/types';

export type Commodity = MaterialCommodity | Weld;

export interface GroupCommodities {
  [key: string]: Commodity[];
}
